import { Component, OnInit, Input, NgModule } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';

import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MasterService } from '../master.service';
import { HttpClient } from '@angular/common/http';

import * as CommonConstants from '../../utils/common.constants';
import { SharedService } from 'src/app/utils/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-speciality',
  templateUrl: './add-speciality.component.html',
  styleUrls: ['./add-speciality.component.scss']
})
export class AddSpecialityComponent implements OnInit {

  @Input() partnerId: number;
  @Input() partnerType: number;
  specialityForm: FormGroup;
  submitted = false;
  departments: any[];
  specList:any[]=[];

  subSpecialityForm: FormGroup;
  specialities: any[];
  columnDefs:any[];
  toggleDiv = true;  

  constructor(private http: HttpClient, private modalService: NgbModal, private formBuilder: FormBuilder, 
    private masterService: MasterService, private sharedService:SharedService, private toastrService:ToastrService, config: NgbTabsetConfig) {
    this.getSpecFormGroup();
    config.justify = 'start';
    config.type = 'pills';

    this.columnDefs = [
      { headerName: 'Speciality', field: 'spltyName' },
      { headerName: 'Department', field: 'deptName'},
      { headerName: 'Number Of Beds', field: 'spetyNuNumberBed' }            
    ];  
    
   }

  ngOnInit() {
    this.loadMasterData();
  }


  loadMasterData() {
    this.masterService.getDepartments().subscribe(response => {
      if (response && response['result']) {
        this.departments = response['result'];
      }
    })
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
  }

  specialityAddModal(addSpeciality) {
    this.modalService.open(addSpeciality, { size: 'lg', container: '.page-content' });
  }
  subSpecialityAddModal(addSubSpeciality){
    this.modalService.open(addSubSpeciality, { size: 'lg', container: '.page-content' });
  }
  hyperSpecialityAddModal(addHyperSpeciality){
    this.modalService.open(addHyperSpeciality, { size: 'lg', container: '.page-content' });
  }

  /**
  * Declare form group
  *  
  */
  private getSpecFormGroup() {
    this.specialityForm = this.formBuilder.group({
      'deptmId': new FormControl(),
      'spetyNuNumberBed': new FormControl(),
      'spetyNuNumberSpecialists': new FormControl(),
      'spltyId': ['', Validators.required],
      "spetyId": new FormControl(),
      "staRecCode": [true]
    })
  }
  
  /**
   * To get form controls
   */
  get f() { return this.specialityForm.controls; }
 // get f() { return this.subSpecialityForm.controls; }
 // get f() { return this.hyperSpecialityForm.controls; }

  saveSpeciality() {
    this.submitted = true;
    if (this.specialityForm.invalid) {
      return;
    }
    let saveData = this.specialityForm.value;
    saveData['partnerId'] = this.partnerId;
    saveData['partnerType'] = this.partnerType;
    saveData["staRecCode"]=this.f.staRecCode.value ? 'A' :'I';
    if (this.specialityForm.value) {
      this.http.post(CommonConstants.SAVE_PARTNER_SPECIALITY, saveData)
        .subscribe(response => {
          if (response['code'] == 0) {
            this.toastrService.success("saved");
            this.specList = this.sharedService.updateDuplicateRecord(response['result'], this.specList, "spetyId", this.specialityForm.value);
            this.modalService.dismissAll("#addSpeciality");
            this.specList =this.specList.map(item => ({ ...item, 
              deptName: item.deptmId ? this.departments.find(obj => +obj.deptmId === +item.deptmId).deptmNameEn : null, 
              spltyName: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).spltyDescEn: null})); 
          }
        })
    }
  }

  onSpecialityRowSelect(spec, addSpec) {
    let data = JSON.parse((JSON.stringify(spec.data)));
    this.modalService.open(addSpec, { size: 'lg', container: '.page-content' });
    this.specialityForm.patchValue([data]);
  }

  toggleContent(){
    this.toggleDiv = !this.toggleDiv;
  }
  
}
